import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const MainContainerFormBody = styled(Box)`
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  overflow: auto;
  margin: 20px 0 20px 0;
`;
